import { Routes, Route } from "react-router-dom";
import {
    Article,
    Blog,
    Home,
    NotFound,
    PrivacyPolicy,
    TermsAndConditions,
} from "../pages";
import { Footer, Navbar } from "../components";

const MainRouter = ({ blogs, publicIP, curpFillType, setIsHomePage }) => {
    return (
        <>
            <Navbar isHomePage={true} publicIP={publicIP} curpFillType={curpFillType} />
            <Routes>
                <Route
                    path="/"
                    element={
                        <Home
                            publicIP={publicIP}
                            curpFillType={curpFillType}
                            blogs={blogs}
                            setIsHomePage={setIsHomePage}
                        />
                    }
                />
                <Route path="/aviso-de-privacidad" element={<PrivacyPolicy />} />
                <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
                <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />
                <Route
                    path="/blog"
                    element={
                        <Blog
                        /* blogs={blogs.slice(1, blogs.length)}
                        latestBlog={blogs.slice(0, 1)} */
                        />
                    }
                />
                <Route path="/blog/:postName" element={<Article blogs={blogs} />} />
                <Route path="/article" element={<Article blogs={blogs} />} />
                <Route path="/article/:postName" element={<Article blogs={blogs} />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer publicIP={publicIP} curpFillType={curpFillType}/>
        </>
    );
};

export default MainRouter; 